import _ from 'lodash';
import { DateTime } from 'luxon';
import { useFormEditorStore } from '../stores/formEditorStore';
import slugify from 'slugify';

const searchFirst = (rules, characteristic) => {
    if (rules?.length) {
        const rule = rules.find((value) => value.feature == characteristic);
        return rule;
    }
};

const searchAll = (rules, characteristic) => {
    if (rules?.length) {
        const rule = rules.filter((value) => value.feature == characteristic);
        return rule;
    }
};

const evaluate = (rule) => {
    const formEditorStore = useFormEditorStore();
    const isNumericSubject = formEditorStore.isNumericWidget(rule.subject);
    const isDateSubject = formEditorStore.isDateWidget(rule.subject);

    let value = formEditorStore.getWidgetValueByName(rule.subject);
    let normalizedRuleValue = rule.value;

    if (isNumericSubject && value) {
        value = _.isNumber(value) ? value : _.isString(value) ? Number(value.replace(',', '.')) : value[0];
    }
    if (isDateSubject && value) {
        if (_.isString(value)) {
            value = new Date(value);
        } else if (_.isDate(value)) {
            value.setHours(0, 0, 0, 0);
            value = value.getTime();
        }
    }

    if (rule.operator != 'in') {
        if (isNumericSubject) {
            normalizedRuleValue = _.isNumber(rule.value) ? rule.value : Number(rule.value.replace(',', '.'));
        } else if (isDateSubject) {
            normalizedRuleValue = DateTime.fromFormat(rule.value, 'dd/MM/yyyy').toJSDate().getTime();
        } else {
            let widget = formEditorStore.getWidgetByName(rule.subject);
            // if (!widget) return widget;
            if (widget.classProperties.name == 'radio-group' || widget.classProperties.name == 'button-group') {
                normalizedRuleValue = slugify(rule.value);
            }
        }
    } else {
        if (isNumericSubject) {
            normalizedRuleValue = rule.valueslist.map((valuelist) => {
                return _.isNumber(valuelist) ? valuelist : Number(valuelist.replace(', ', '.'));
            });
        } else if (isDateSubject) {
            normalizedRuleValue = rule.valueslist.map((valuelist) => {
                return DateTime.fromFormat(valuelist, 'dd/MM/yyyy').toJSDate().getTime();
            });
        } else {
            let widget = formEditorStore.getWidgetByName(rule.subject);
            if (widget.classProperties.name == 'radio-group' || widget.classProperties.name == 'button-group') {
                normalizedRuleValue = rule.valueslist.map((valuelist) => {
                    return slugify(valuelist);
                });
            }
        }
    }
    return evaluateCalc(value, rule.operator, normalizedRuleValue);
};

const evaluateLocal = (rule, _formDefIndex, data) => {
    const isNumericSubject = isNumericLocal(rule.subject, _formDefIndex);
    const isDateSubject = isDateLocal(rule.subject, _formDefIndex);

    let value = getWidgetValueByNameLocal(rule.subject, _formDefIndex, data);
    let normalizedRuleValue = rule.value;

    if (isNumericSubject && value) {
        value = _.isNumber(value) ? value : _.isString(value) ? Number(value.replace(',', '.')) : value[0];
    }
    if (isDateSubject && value) {
        if (_.isString(value)) {
            value = new Date(value);
        } else if (_.isDate(value)) {
            value.setHours(0, 0, 0, 0);
            value = value.getTime();
        }
    }

    if (rule.operator != 'in') {
        if (isNumericSubject) {
            normalizedRuleValue = _.isNumber(rule.value) ? rule.value : Number(rule.value.replace(',', '.'));
        } else if (isDateSubject) {
            normalizedRuleValue = DateTime.fromFormat(rule.value, 'dd/MM/yyyy').toJSDate();
        } else {
            let widget = getWidgetByNameLocal(rule.subject, _formDefIndex);
            // if (!widget) return widget;
            if (widget.classProperties.name == 'radio-group' || widget.classProperties.name == 'button-group') {
                normalizedRuleValue = slugify(rule.value);
            }
        }
    } else {
        if (isNumericSubject) {
            normalizedRuleValue = rule.valueslist.map((valuelist) => {
                return _.isNumber(valuelist) ? valuelist : Number(valuelist.replace(', ', '.'));
            });
        } else if (isDateSubject) {
            normalizedRuleValue = rule.valueslist.map((valuelist) => {
                return DateTime.fromFormat(valuelist, 'dd/MM/yyyy').toJSDate().getTime();
            });
        } else {
            let widget = getWidgetByNameLocal(rule.subject, _formDefIndex);
            if (widget.classProperties.name == 'radio-group' || widget.classProperties.name == 'button-group') {
                normalizedRuleValue = rule.valueslist.map((valuelist) => {
                    return slugify(valuelist);
                });
            }
        }
    }

    return evaluateCalc(value, rule.operator, normalizedRuleValue);
    // return evaluateCalcLocal(rule, value);
};
const evaluateCalc = (subjectValue, operator, conditionValue) => {
    let result = false;

    switch (operator) {
        case 'equal': {
            result = conditionValue == subjectValue;
            break;
        }
        case 'not-equal': {
            result = conditionValue != subjectValue;
            break;
        }
        case 'greater-than': {
            result = subjectValue > conditionValue;
            break;
        }
        case 'greater-or-equal-than': {
            result = subjectValue >= conditionValue;
            break;
        }
        case 'less-than': {
            result = subjectValue < conditionValue;
            break;
        }
        case 'less-or-equal-than': {
            result = subjectValue <= conditionValue;
            break;
        }
        case 'contains': {
            result = conditionValue && subjectValue && subjectValue.includes(conditionValue);
            break;
        }
        case 'is-checked': {
            result = subjectValue == true;
            break;
        }
        case 'is-not-checked': {
            result = !subjectValue || subjectValue == false;
            break;
        }
        case 'selected': {
            result = !!subjectValue;
            break;
        }
        case 'not-selected': {
            result = !subjectValue;
            break;
        }
        case 'in': {
            if (_.isArray(subjectValue)) {
                result = conditionValue.includes(subjectValue);
            } else {
                result = conditionValue.includes(subjectValue);
            }
            break;
        }
    }
    return result;
};

const isNumericLocal = (subject, _formDefIndex) => {
    const widget = _.find(_formDefIndex, function (o) {
        return o.instanceProperties.name == subject;
    });
    if (widget) {
        return widget.classProperties.name === 'input-number' || widget.classProperties.name === 'range';
    }
};
const isDateLocal = (subject, _formDefIndex) => {
    const widget = _.find(_formDefIndex, function (o) {
        return o.instanceProperties.name == subject;
    });
    if (widget) {
        return widget.classProperties.name === 'input-date';
    }
};
const getWidgetByNameLocal = (subject, _formDefIndex) => {
    const widget = _.find(_formDefIndex, function (o) {
        return o.instanceProperties.name == subject;
    });
    if (widget) {
        return widget;
    }
};
const getWidgetValueByNameLocal = (subject, _formDefIndex, data) => {
    const widget = _.find(_formDefIndex, function (o) {
        return o.instanceProperties.name == subject;
    });
    if (widget && data) {
        return data[subject];
    }
    return null;
};

const searchAndEvaluate = (widget, feature, defaultResult) => {
    const rules = searchAll(widget.instanceProperties.rules, feature);

    if (rules?.length) {
        const rulesResults = rules.reduce((carry, rule) => {
            let r = false;
            r = evaluate(rule) ?? false;
            if (!Object.prototype.hasOwnProperty.call(carry, rule.subject)) {
                carry[rule.subject] = r;
            } else {
                carry[rule.subject] = carry[rule.subject] || r;
            }
            return carry;
        }, {});
        const rulesOutcome = Object.values(rulesResults).reduce((carry, rulesResult) => {
            return carry && rulesResult;
        }, true);
        console.log('RULES RESULTS: ', rulesResults);
        console.log('RULES OUTCOME: ', rulesOutcome);
        return rulesOutcome;
    } else {
        if (feature === 'disabled') {
            // console.log('IS DISABLED', widget);
            return widget.instanceProperties.disabled;
        }
    }

    return defaultResult;
};

const searchAndEvaluateLocal = (widget, widgetIndex, data, feature, defaultResults) => {
    const rules = searchAll(widget.instanceProperties.rules, feature);

    if (rules?.length) {
        const rulesResults = rules.reduce((carry, rule) => {
            let r = evaluateLocal(rule, widgetIndex, data);
            if (!Object.prototype.hasOwnProperty.call(carry, rule.subject)) {
                carry[rule.subject] = r;
            } else {
                carry[rule.subject] = carry[rule.subject] || r;
            }
            return carry;
        }, {});
        const rulesOutcome = Object.values(rulesResults).reduce((carry, ruleResult) => {
            return carry && ruleResult;
        }, true);
        console.log('RULES RESULTS: ', rulesResults);
        console.log('RULES OUTCOME: ', rulesOutcome);
        return rulesOutcome;
    } else {
        if (feature === 'disabled') {
            // console.log('IS DISABLED', widget);
            return widget.instanceProperties.disabled;
        }
    }

    return defaultResults;
};

export default {
    isVisible: (widget) => {
        return searchAndEvaluate(widget, 'visibility', true);
    },
    isVisibleLocal: (widget, _formDefIndex, data) => {
        return searchAndEvaluateLocal(widget, _formDefIndex, data, 'visibility', true);
    },
    isDisabled: (widget) => {
        return searchAndEvaluate(widget, 'disabled', false);
    },
    isDisabledLocal: (widget, _formDefIndex, data) => {
        return searchAndEvaluateLocal(widget, _formDefIndex, data, 'disabled', false);
    },
    isRequired: (widget) => {
        return searchAndEvaluate(widget, 'required', false);
    },
    isRequiredLocal: (widget, _formDefIndex, data) => {
        return searchAndEvaluateLocal(widget, _formDefIndex, data, 'required', false);
    },

    hasAssignRule: (widget) => {
        const rule = searchFirst(widget.instanceProperties.rules, 'assign');
        if (rule) {
            return true;
        }
        return false;
    },

    isConditionSubjectForAssignRule: (widget) => {
        const formEditorStore = useFormEditorStore();

        const rule = Object.keys(formEditorStore.formDefIndex).find((widgetDefId) => {
            return formEditorStore.formDefIndex[widgetDefId].instanceProperties.rules?.find((rule) => {
                return rule.feature == 'assign' && rule.subject == widget.instanceProperties.name;
            });
        });
        if (rule) {
            return true;
        }
        return false;
    },

    execAssign: (widget) => {
        const rule = searchFirst(widget.instanceProperties.rules, 'assign');
        const formEditorStore = useFormEditorStore();
        if (rule) {
            const value = evaluate(rule);
            console.log('ASSIGN:', value, rule.destination, rule.destinationvalue);
            if (value) {
                formEditorStore.setWidgetValueByName(rule.destination, rule.destinationvalue);
            }
        }
    },
    execAssignsWithConditionalSubject: (widget) => {
        const formEditorStore = useFormEditorStore();
        const widgetWithAssignRulesForConditionalSubject = Object.keys(formEditorStore.formDefIndex).reduce((carry, widgetDefId) => {
            if (
                formEditorStore.formDefIndex[widgetDefId].instanceProperties.rules?.find(
                    (rule) => rule.feature == 'assign' && rule.subject == widget.instanceProperties.name
                )
            ) {
                carry.push(formEditorStore.formDefIndex[widgetDefId]);
            }
            return carry;
        }, []);
        widgetWithAssignRulesForConditionalSubject.forEach((widgetDef) => {
            widgetDef.instanceProperties.rules.forEach((rule) => {
                if (rule.feature == 'assign' && rule.subject == widget.instanceProperties.name) {
                    const value = evaluate(rule);
                    console.log('ASSIGN:', value, rule.destination, rule.destinationvalue);
                    if (value) {
                        if (formEditorStore.getWidgetValueByName(rule.destination) != rule.destinationvalue)
                            formEditorStore.setWidgetValueByName(rule.destination, rule.destinationvalue);
                    }
                }
            });
        });
    },
};
